var _this = this;
import * as tslib_1 from "tslib";
import { submitStateActionTypes } from './ActionTypes';
export var submitStateAction = function () {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var submitStateActionResponse;
        return tslib_1.__generator(this, function (_a) {
            submitStateActionResponse = {
                type: submitStateActionTypes.SUBMITED_STATE_ACTION
            };
            return [2 /*return*/, dispatch(submitStateActionResponse)];
        });
    }); };
};
export var submitProductTypeChangedAction = function (productType) {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var productTypeChangedStateActionResponse;
        return tslib_1.__generator(this, function (_a) {
            productTypeChangedStateActionResponse = {
                type: submitStateActionTypes.PRODUCT_TYPE_CHANGED_STATE_ACTION,
                productType: productType
            };
            return [2 /*return*/, dispatch(productTypeChangedStateActionResponse)];
        });
    }); };
};
export var submitCancelStateAction = function () {
    return function (dispatch) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var submitStateActionResponse;
        return tslib_1.__generator(this, function (_a) {
            submitStateActionResponse = {
                type: submitStateActionTypes.SUBMIT_CANCEL_STATE_ACTION
            };
            return [2 /*return*/, dispatch(submitStateActionResponse)];
        });
    }); };
};
